var NotificationActiveTab;
(function (NotificationActiveTab) {
    NotificationActiveTab["NEWEST"] = "newest";
    NotificationActiveTab["READ"] = "read";
})(NotificationActiveTab || (NotificationActiveTab = {}));
export { NotificationActiveTab };
//# sourceMappingURL=types.js.map